import { render, staticRenderFns } from "./CargaInicial.vue?vue&type=template&id=d2bf0e2a&"
var script = {}


/* normalize component */
import normalizer from "!../../cliente-cocina/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports